import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (typeof console !== 'undefined' && console.error) {
      console.error('Debt clock render error:', error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="ctf-debt-clock-error">
          {this.props.fallback || 'Debt clock unavailable.'}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
